import api from './api'

export const loyaltyService = {
  // Public — get current settings
  getSettings: async () => {
    const { data } = await api.get('/loyalty/settings')
    return data.data
  },

  // Admin — update settings
  updateSettings: async (payload) => {
    const { data } = await api.patch('/loyalty/settings', payload)
    return data.data
  },

  // Admin — get a user's loyalty account + transactions
  getUserAccount: async (userId, params = {}) => {
    const { data } = await api.get(`/loyalty/admin/users/${userId}`, { params })
    return data.data
  },

  // Admin — manually adjust user's points
  adjustPoints: async (userId, points, description) => {
    const { data } = await api.post(`/loyalty/admin/users/${userId}/adjust`, { points, description })
    return data.data
  },

  // Admin — trigger points expiry job (run manually or via cron)
  triggerExpirePoints: async () => {
    const { data } = await api.post('/loyalty/expire-points')
    return data.data
  },

  // Admin — add a category to the redeemable list
  addRedeemableCategory: async (categoryId) => {
    const { data } = await api.post('/loyalty/settings/redeemable-categories', { categoryId })
    return data.data
  },

  // Admin — remove a category from the redeemable list
  removeRedeemableCategory: async (categoryId) => {
    const { data } = await api.delete(`/loyalty/settings/redeemable-categories/${categoryId}`)
    return data.data
  },
}
